module.exports = "images/high_performance_workstations.png";